import Block from './Block'
import App from '../App'

export default class References extends Block {
    constructor(el, destroyLast) {
        super(el, destroyLast)

        this.filtersArray = []
        this.minChars = 4
        this.visibleReferences = App.isMobile ? 5 : 13

        this.fillSelect()
        this.setWrapperHeight()
    }

    bindMethods() {
      this.applyFilter = this.applyFilter.bind(this)
      this.searchReferences = this.searchReferences.bind(this)
      this.fillSelect = this.fillSelect.bind(this)
      this.resetSelect = this.resetSelect.bind(this)
      this.resetSearch = this.resetSearch.bind(this)
      this.onCrossClick = this.onCrossClick.bind(this)
      this.onResetButtonClick = this.onResetButtonClick.bind(this)
      this.setWrapperHeight = this.setWrapperHeight.bind(this)
    }

    getElems() {
      this.refs = []
      this.names = []

      this.referencesWrapper = this.el.querySelector('.tables-wrapper')
      this.references = this.el.querySelectorAll('.table__references')
      this.referencesNames = this.el.querySelectorAll('.table__references-title .reference-title')
      this.filters = this.el.querySelectorAll('.filter')
      this.filterButton = this.el.querySelector('.filter-button')
      this.search = this.el.querySelector('.search')
      this.cross = this.el.querySelector('.cross')
      this.resetButton = this.el.querySelector('.reset-button')
      this.notFoundText = this.el.querySelector('.table__not-found')

      for (let j = 0; j < this.referencesNames.length; j++) {
        const name = this.referencesNames[j].innerHTML.toLowerCase()

        this.names.push(name)
      }

      for (let i = 0; i < this.references.length; i++) {

        const reference = {
          el: this.references[i],
          name: this.references[i].querySelector('.table__references-title .reference-title').innerHTML,
          filters: this.references[i].querySelectorAll('.table__references-filter')
        }

        this.refs.push(reference)
      }
    }

    events() {
      this.filterButton.addEventListener('click', this.applyFilter)
      this.search.addEventListener('keyup', this.searchReferences)
      this.cross.addEventListener('click', this.onCrossClick)
      this.resetButton.addEventListener('click', this.onResetButtonClick)
    }

    setWrapperHeight() {
      const length = this.references.length >= this.visibleReferences ? this.visibleReferences : this.references.length
      let height = 0

      for (let i = 0; i < length; i++) {
        const referenceHeight = this.references[i].offsetHeight + 10

        height += referenceHeight
      }

      this.referencesWrapper.style.height = height + 'px'
    }

    fillSelect() {
      for (let k = 0; k < this.filters.length; k++) {
        const filterArray = []
        const slug = this.slugify(this.filters[k].firstElementChild.innerHTML)
        const filters = this.el.querySelectorAll('[data-filter-' + slug + ']')

        // Add filter name in select list if it doesn't already exists
        for (let i = 0; i < filters.length; i++) {
          const filterName = filters[i].querySelector('.filter-name').innerHTML

          if (filterArray.indexOf(filterName) === -1) filterArray.push(filterName)
        }

        this.filtersArray.push(filterArray)

        // For each filter in the category, create an <option> tag and add it to <select>
        for (let j = 0; j < filterArray.length; j++) {
          const option = document.createElement('option')

          option.value = filterArray[j]
          option.innerHTML = filterArray[j]

          this.filters[k].appendChild(option)
        }
      }
    }

    resetSelect() {
      for (let i = 0; i < this.filters.length; i++) {
        this.filters[i].selectedIndex = 0;
      }

      this.notFoundText.classList.contains('active') && this.notFoundText.classList.remove('active')
    }

    resetSearch() {
      this.search.value = ''
      this.cross.classList.contains('active') && this.cross.classList.remove('active')
      this.notFoundText.classList.contains('active') && this.notFoundText.classList.remove('active')
    }

    onCrossClick() {
      this.resetSearch()

      for (let i = 0; i < this.refs.length; i++) {
        this.refs[i].el.classList.contains('active') && this.refs[i].el.classList.remove('active')
        this.refs[i].el.classList.remove('inactive')
      }
    }

    onResetButtonClick() {
      this.resetSelect()

      for (let i = 0; i < this.refs.length; i++) {
        this.refs[i].el.classList.contains('active') && this.refs[i].el.classList.remove('active')
        this.refs[i].el.classList.remove('inactive')
      }
    }

    searchReferences() {
      if (this.search.value.length >= this.minChars) {
        this.resetSelect()
        this.cross.classList.add('active')

        this.hasSearched = true

        const searchedReference = this.search.value.toLowerCase()

        const results = this.names.filter((name) => name.indexOf(searchedReference) !== -1)

        if (results && results.length) {
          this.notFoundText.classList.contains('active') && this.notFoundText.classList.remove('active')
        } else {
          this.notFoundText.classList.add('active')
        }

        for (let i = 0; i < this.names.length; i++) {
          if (this.names[i].includes(searchedReference)) {
            this.refs[i].el.classList.remove('inactive')
            this.refs[i].el.classList.add('active')
          } else {
            this.refs[i].el.classList.remove('active')
            this.refs[i].el.classList.add('inactive')
          }
        }
      } else if (this.search.value.length < this.minChars && this.hasSearched) {
        for (let j = 0; j < this.refs.length; j++) {
          this.refs[j].el.classList.remove('active')
          this.refs[j].el.classList.remove('inactive')
          this.notFoundText.classList.contains('active') && this.notFoundText.classList.remove('active')
        }

        this.cross.classList.remove('active')

        this.hasSearched = false
      }
    }

    applyFilter() {
      this.resetSearch()

      const filterValues = []
      let result = this.refs

      for (let i = 0; i < this.filters.length; i++) this.filters[i].value !== '' && filterValues.push(this.filters[i].value)
      for (let j = 0; j < filterValues.length; j++) result = result.filter((aRef) => Array.from(aRef.filters).filter((aFilter) => aFilter.querySelector('.filter-name').innerHTML === filterValues[j]).length)

      this.displayFilter(result)
    }

    displayFilter(result) {
      if (!result || !result.length) {
        this.notFoundText.classList.add('active')
      } else {
        this.notFoundText.classList.contains('active') && this.notFoundText.classList.remove('active')
      }

      for (let i = 0; i < this.refs.length; i++) {
        this.refs[i].el.classList.contains('active') && this.refs[i].el.classList.remove('active')
        this.refs[i].el.classList.add('inactive')
      }

      for (let j = 0; j < result.length; j++) {
        result[j].el.classList.add('active')
        result[j].el.classList.remove('inactive')
      }
    }

    slugify(string) {
      /* eslint-disable */
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')
      return string.toString().toLowerCase()
          .replace(/\s+/g, '-')
          .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, '-and-') // Replace & with 'and'
          .replace(/[^\w\-]+/g, '') // Remove all non-word characters
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, '') // Trim - from end of text
      /* eslint-enable */
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/References.js